// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__iutnB","flatColors":"styles_flatColors__w85C6","icon":"styles_icon__QSaz_"};